import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './index.css';
import { isArrayWithItems } from '../../../utils';
import { ILegendItem } from '../../../utils/legend';

export interface ILegendModalProps {
  isOpen: boolean;
  legendData: ILegendItem[];

  close(): void;
}

export class LegendModal extends React.PureComponent<ILegendModalProps, {}> {
  public render() {
    const { legendData } = this.props;

    if (!isArrayWithItems(legendData)) {
      return null;
    }

    return (
      <ModalWindow
        open={this.props.isOpen}
        onClose={this.close}
        content={
          <>
            <ul className={styles['list']}>
              {legendData.map(item => (
                <li
                  key={item.color}
                  className={styles['item']}
                  style={{
                    borderColor: item.color,
                  }}
                >
                  {item.title}
                </li>
              ))}
            </ul>
            <button className={styles['close']} onClick={this.close}>
              Закрыть
            </button>
          </>
        }
      />
    );
  }

  private close = () => {
    this.props.close();
  };
}
